import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLibraryWorkoutsPage } from "src/pages/CoachLibraryWorkoutsPage";
import { createPersonalLibraryWorkoutsRepository } from "src/repositories/workouts/createPersonalLibraryWorkoutsRepository";

export const WORKOUTS_DEFAULT_PAGE_SIZE = 10;

const routeSearchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
  sources: z.array(z.enum(["library", "mine"])).optional(),
  labels: z.array(z.string()).optional(),
});

export function sourcesToFilter(
  sources: ("library" | "mine")[],
): "all" | "library" | "mine" {
  if (sources.length === 1) return sources[0];

  return "all";
}

export const Route = createFileRoute("/_auth/_coach/library/workouts/")({
  component: CoachLibraryWorkoutsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ context, deps }) {
    return await loaderHandler(async () => {
      const query = deps.q || "";
      const pageIndex = deps.p || 0;
      const pageSize = deps.ps || WORKOUTS_DEFAULT_PAGE_SIZE;
      const sources = deps.sources ?? [];
      const filter = sourcesToFilter(sources);

      const workoutsRepository = createPersonalLibraryWorkoutsRepository();
      const workoutList = await context.queryClient.query({
        ...workoutsRepository.listOptions({
          pageIndex,
          query,
          pageSize,
          filter,
          labelIds: deps.labels,
        }),
        staleTime: "static",
      });

      return {
        data: {
          workoutList,
        },
      };
    });
  },
});
